import React, {Component} from 'react';
import { Responsive } from 'semantic-ui-react';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';

export default class MainMenu extends Component {

    render() {
        return (
            <div style={{paddingBottom: '75px'}}>
                <Responsive minWidth={1024}>
                    <DesktopMenu />
                </Responsive>
                <Responsive maxWidth={1023}>
                    <MobileMenu />
                </Responsive>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/common/menu/MainMenu.jsx